import { render, staticRenderFns } from "./EditLevel.vue?vue&type=template&id=21bb6e8a&"
import script from "./EditLevel.vue?vue&type=script&lang=js&"
export * from "./EditLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports